export function generateSecurePassword(length: number = 32): string {
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const numberChars = '0123456789';
  const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  const allChars = uppercaseChars + lowercaseChars + numberChars + specialChars;

  const randomValues = new Uint32Array(length);
  crypto.getRandomValues(randomValues);

  const mandatoryChars = [
    uppercaseChars[randomValues[0] % uppercaseChars.length],
    lowercaseChars[randomValues[1] % lowercaseChars.length],
    numberChars[randomValues[2] % numberChars.length],
    specialChars[randomValues[3] % specialChars.length],
  ];

  const remainingLength = length - mandatoryChars.length;
  const randomChars: string[] = [];

  for (let i = 0; i < remainingLength; i++) {
    randomChars.push(allChars[randomValues[i + 4] % allChars.length]);
  }

  const passwordArray = [...mandatoryChars, ...randomChars];
  const shuffleValues = new Uint32Array(passwordArray.length);
  crypto.getRandomValues(shuffleValues);

  for (let i = passwordArray.length - 1; i > 0; i--) {
    const j = shuffleValues[i] % (i + 1);
    [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
  }

  return passwordArray.join('');
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function normalizeEmail(email: string): string {
  return email.toLowerCase().trim();
}

export function isValidOTP(otp: string, expectedLength: number = 6): boolean {
  const otpRegex = new RegExp(`^\\d{${expectedLength}}$`);
  return otpRegex.test(otp);
}
